/**
 * Diff marks for the document comparison viewer.
 *
 * Three TipTap Mark extensions that visually annotate text-level changes:
 * - DiffInsert: green highlight for newly added text
 * - DiffDelete: red strikethrough for removed text
 * - DiffFormat: blue dotted underline for formatting-only changes
 *
 * These marks are non-exclusive (can coexist with bold, italic, etc.)
 * and non-inclusive (don't extend to adjacent typed text).
 */

import { Mark } from "@tiptap/react";

export const DiffInsert = Mark.create({
  name: "diffInsert",

  excludes: "",

  inclusive: false,

  parseHTML() {
    return [{ tag: "ins.diff-insert" }];
  },

  renderHTML() {
    return ["ins", { class: "diff-insert" }, 0];
  },
});

export const DiffDelete = Mark.create({
  name: "diffDelete",

  excludes: "",

  inclusive: false,

  parseHTML() {
    return [{ tag: "del.diff-delete" }];
  },

  renderHTML() {
    return ["del", { class: "diff-delete" }, 0];
  },
});

export const DiffFormat = Mark.create({
  name: "diffFormat",

  excludes: "",

  inclusive: false,

  parseHTML() {
    return [{ tag: "span.diff-format" }];
  },

  renderHTML() {
    return ["span", { class: "diff-format" }, 0];
  },
});
